import { Module } from '@nestjs/common'
import { TenantController } from './controllers'
import { TenantSeedService, TenantService } from './services'

@Module({
	controllers: [TenantController],
	providers: [TenantService, TenantSeedService],
})
export class TenantModule {}
